import { createClient } from '@supabase/supabase-js'

const supabaseURL:string = process.env.REACT_APP_SUPABASE_URL || ''
const supabaseKey:string = process.env.REACT_APP_SUPABASE_KEY || ''

const supabase = createClient(supabaseURL, supabaseKey)

export default supabase